import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Box, Page } from '@zillow/constellation-10';

import { getCachedPropertyAddress } from '../../../../../utils/navigationCacheUtils';

import { useAuth } from '../../../../../components/AuthProvider';
import ConnectedModuleCard from '../../../../../components/ConnectedModuleCard';
import RestrictedListingBanner from '../../../../../components/CreateListingPage/RestrictedListingBanner';
import Navigation from '../../../../../components/Dashboard/Navigation';
import PropertyCard from '../../../../../components/Dashboard/PropertyCard';
import RentGuaranteeBannerMultiPolicy from '../../../../../components/Dashboard/RentGuaranteeBannerMultiPolicy';
import {
  dashboardBodyContentStyles,
  dashboardHeaderContainerStyles,
  dashboardHeaderContentStyles,
} from '../../../../../components/Dashboard/styles';
import ListingPage from '../../../../../components/ListingPage';
import AuthCheckWrapper from '../../../../../containers/AuthCheckWrapper';

import { emitViewDashboardTabEvent } from '../../../../../analytics/events/dashboardPage';

const DashboardListingPage = () => {
  const router = useRouter();
  const listingAlias = router.isReady ? (router.query.listingAlias as string) : '';
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      emitViewDashboardTabEvent({
        user,
        triggerLocationNm: 'zrm_properties_listing',
        triggerSourceNm: 'zrm_properties_listing',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.email]);

  const cachedAddress = typeof window !== 'undefined' ? getCachedPropertyAddress(listingAlias) : null;

  const skeleton = (
    <Page.Root css={{ backgroundColor: 'bg.screen.neutral' }}>
      <Box css={dashboardHeaderContainerStyles}>
        <Page.Content css={dashboardHeaderContentStyles}>
          <PropertyCard listingAlias={listingAlias} fallbackAddress={cachedAddress ?? undefined} />
          <Box css={{ marginBottom: '1000' }} />
          <Navigation listingAlias={listingAlias} activeTab="listing" />
        </Page.Content>
      </Box>
      <Page.Content css={dashboardBodyContentStyles}>
        <ConnectedModuleCard title="Listing" isLoading={true}>
          <Box css={{ minHeight: '200px' }} />
        </ConnectedModuleCard>
      </Page.Content>
    </Page.Root>
  );

  return (
    <AuthCheckWrapper loading={skeleton} redirecting={skeleton}>
      <Page.Root css={{ backgroundColor: 'bg.screen.neutral' }}>
        <Box css={dashboardHeaderContainerStyles}>
          <RestrictedListingBanner isFromDashboard={true} />

          <Page.Content css={dashboardHeaderContentStyles}>
            <PropertyCard listingAlias={listingAlias} fallbackAddress={cachedAddress ?? undefined} />
            <Box css={{ marginBottom: '1000' }} />
            <Navigation listingAlias={listingAlias} activeTab="listing" />
          </Page.Content>
        </Box>
        <RentGuaranteeBannerMultiPolicy listingAlias={listingAlias} />
        <Page.Content css={dashboardBodyContentStyles}>
          <ListingPage listingAlias={listingAlias} />
        </Page.Content>
      </Page.Root>
    </AuthCheckWrapper>
  );
};

export default DashboardListingPage;
